"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnAddLabel = void 0;
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const providers_1 = require("../providers");
const arrangeLabels_1 = require("../utils/arrangeLabels");
const getLabelPosition_1 = require("../utils/getLabelPosition");
const useLabels_1 = require("./useLabels");
const useLatestLabel_1 = require("./useLatestLabel");
const DEFAULT_LABEL_WIDTH = 280;
// eslint-disable-next-line max-lines-per-function
function useOnAddLabel(toolType, setIsAddingLabels) {
    const { labels, isGroupMode, selectedLabelID } = (0, useLabels_1.useLabels)();
    const latestLabel = (0, useLatestLabel_1.useLatestLabel)();
    const windowSize = (0, ui_1.useScreenSize)();
    const toolsService = (0, providers_1.useToolsService)();
    const labelManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getLabelToolManager();
    const bridge = (0, bridge_1.useBridge)();
    const [latestAddedLabel, setLatestAddedLabel] = (0, react_1.useState)(null);
    const prevWindowSize = (0, react_1.useRef)(windowSize);
    // eslint-disable-next-line max-lines-per-function
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f;
        if (latestLabel === undefined) {
            return;
        }
        if (latestLabel === null) {
            labelManager === null || labelManager === void 0 ? void 0 : labelManager.resetGroupMode();
            bridge === null || bridge === void 0 ? void 0 : bridge.exitLabelGroupMode();
            labelManager === null || labelManager === void 0 ? void 0 : labelManager.deselectLabel();
            localStorage.removeItem('groupModeID');
            return;
        }
        if (prevWindowSize.current === null) {
            prevWindowSize.current = windowSize;
        }
        setIsAddingLabels(true);
        const isEmptyGroupLabel = latestLabel.type === bridge_schema_1.LabelType.Group &&
            latestLabel.object === null &&
            latestLabel.parts === null;
        const isCurrentSelectionEmptyGroup = selectedLabelID &&
            labels.some(label => label.identifier === selectedLabelID &&
                label.type === bridge_schema_1.LabelType.Group &&
                label.object === null &&
                label.parts === null);
        if (isGroupMode && isEmptyGroupLabel && !isCurrentSelectionEmptyGroup) {
            labelManager === null || labelManager === void 0 ? void 0 : labelManager.resetGroupMode();
            bridge === null || bridge === void 0 ? void 0 : bridge.exitLabelGroupMode();
            labelManager === null || labelManager === void 0 ? void 0 : labelManager.deselectLabel();
            localStorage.removeItem('groupModeID');
            return;
        }
        let arrangedLabels = [];
        const existingLabel = labels === null || labels === void 0 ? void 0 : labels.find(label => {
            var _a, _b;
            return ((_a = label.object) === null || _a === void 0 ? void 0 : _a.identifier) === ((_b = latestLabel.object) === null || _b === void 0 ? void 0 : _b.identifier) &&
                label.type === latestLabel.type;
        });
        if (existingLabel && latestLabel.type !== bridge_schema_1.LabelType.Group) {
            return;
        }
        const originalPosition = (0, getLabelPosition_1.getLabelPosition)(latestLabel.position, toolType === bridge_schema_1.ToolType.LabelsLeft
            ? bridge_schema_1.LabelOrientation.Left
            : bridge_schema_1.LabelOrientation.Right, DEFAULT_LABEL_WIDTH, windowSize
        // scale
        );
        let updatedLabel;
        if (latestLabel.type === bridge_schema_1.LabelType.Group &&
            latestLabel.object === null &&
            latestLabel.parts === null) {
            // labelManager?.resetGroupMode();
            // bridge?.exitLabelGroupMode();
            // labelManager?.deselectLabel();
            // localStorage.removeItem('groupModeID');
            // return;
            if (prevWindowSize.current !== null &&
                (windowSize.width !== prevWindowSize.current.width ||
                    windowSize.height !== prevWindowSize.current.height)) {
                prevWindowSize.current = windowSize;
                return;
            }
            const addedLabel = (_a = labelManager === null || labelManager === void 0 ? void 0 : labelManager.addLabel(Object.assign(Object.assign({}, latestLabel), { position: originalPosition, target: latestLabel.position, identifier: Math.round(Math.random() * 10e6).toString() }))) !== null && _a !== void 0 ? _a : null;
            setLatestAddedLabel(addedLabel);
            if (addedLabel) {
                arrangedLabels = (0, arrangeLabels_1.arrangeLabels)([...(labels || []), addedLabel], windowSize.height);
                labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateLabels(arrangedLabels);
                labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateUndoRedoHistory();
                labelManager === null || labelManager === void 0 ? void 0 : labelManager.selectLabel(addedLabel.identifier);
            }
            prevWindowSize.current = windowSize;
            return;
        }
        if (isGroupMode) {
            const parentLabel = latestAddedLabel !== null && latestAddedLabel !== void 0 ? latestAddedLabel : labels.find(label => label.identifier === selectedLabelID);
            if (!parentLabel) {
                return;
            }
            const label = labels === null || labels === void 0 ? void 0 : labels.find(({ identifier }) => identifier === parentLabel.identifier);
            if (!label) {
                return;
            }
            updatedLabel = label;
            const existingPartIndex = (_b = label.parts) === null || _b === void 0 ? void 0 : _b.findIndex(part => { var _a; return part.object.identifier === ((_a = latestLabel.object) === null || _a === void 0 ? void 0 : _a.identifier); });
            if (existingPartIndex !== undefined && existingPartIndex !== -1) {
                (_c = label.parts) === null || _c === void 0 ? void 0 : _c.splice(existingPartIndex, 1);
                label.parts = [...((_d = label.parts) !== null && _d !== void 0 ? _d : [])];
            }
            else {
                label.parts = [
                    ...(label.parts || []),
                    {
                        object: latestLabel.object,
                        target: {
                            x: latestLabel.position.x,
                            y: latestLabel.position.y,
                        },
                        position3D: latestLabel.position3D,
                    },
                ];
            }
            arrangedLabels = (0, arrangeLabels_1.arrangeLabels)([...labels], windowSize.height);
            if (existingPartIndex === undefined || existingPartIndex === -1) {
                setLatestAddedLabel(latestAddedLabel); //NOSONAR
                labelManager === null || labelManager === void 0 ? void 0 : labelManager.selectPart(label.identifier, latestLabel.object.identifier);
            }
        }
        else {
            const selectedGrouplabelID = localStorage.getItem('groupModeID');
            if (selectedGrouplabelID) {
                bridge === null || bridge === void 0 ? void 0 : bridge.enterLabelGroupMode();
                const selectedLabel = labels.find(label => label.identifier === selectedGrouplabelID);
                // eslint-disable-next-line max-depth
                if (!selectedLabel) {
                    return;
                }
                const partExists = (_e = selectedLabel === null || selectedLabel === void 0 ? void 0 : selectedLabel.parts) === null || _e === void 0 ? void 0 : _e.some(part => part.object.identifier === latestLabel.object.identifier);
                // eslint-disable-next-line max-depth
                if (partExists) {
                    return;
                }
                selectedLabel.parts = [
                    ...(selectedLabel.parts || []),
                    {
                        object: latestLabel.object,
                        target: {
                            x: latestLabel.position.x,
                            y: latestLabel.position.y,
                        },
                        position3D: latestLabel.position3D,
                    },
                ];
                arrangedLabels = (0, arrangeLabels_1.arrangeLabels)([...labels], windowSize.height);
                labelManager === null || labelManager === void 0 ? void 0 : labelManager.selectPart(selectedLabel.identifier, latestLabel.object.identifier);
                return;
            }
            const isGroupLabel = latestLabel.type === bridge_schema_1.LabelType.Group;
            if (isGroupLabel) {
                latestLabel.parts = [];
                latestLabel.parts.push({
                    object: latestLabel.object,
                    target: {
                        x: latestLabel.position.x,
                        y: latestLabel.position.y,
                    },
                    position3D: latestLabel.position3D,
                });
            }
            const addedLabel = (_f = labelManager === null || labelManager === void 0 ? void 0 : labelManager.addLabel(Object.assign(Object.assign({}, latestLabel), { position: originalPosition, target: latestLabel.position, identifier: Math.round(Math.random() * 10e6).toString() }))) !== null && _f !== void 0 ? _f : null;
            if (!addedLabel) {
                return;
            }
            setLatestAddedLabel(addedLabel);
            if (isGroupLabel) {
                labelManager === null || labelManager === void 0 ? void 0 : labelManager.selectPart(addedLabel.identifier, latestLabel.object.identifier);
            }
            arrangedLabels = (0, arrangeLabels_1.arrangeLabels)([...(labels || []), addedLabel], windowSize.height);
            updatedLabel = addedLabel;
        }
        labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateLabels(arrangedLabels);
        labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateUndoRedoHistory();
        if (updatedLabel) {
            if (updatedLabel.type !== bridge_schema_1.LabelType.Group) {
                labelManager === null || labelManager === void 0 ? void 0 : labelManager.selectLabel(updatedLabel.identifier);
            }
            else {
                // eslint-disable-next-line max-depth
                if (updatedLabel.parts && updatedLabel.parts.length > 0) {
                    labelManager === null || labelManager === void 0 ? void 0 : labelManager.selectPart(updatedLabel.identifier, updatedLabel.parts[updatedLabel.parts.length - 1].object.identifier);
                }
                else {
                    console.error('Updated label has no parts:', updatedLabel);
                }
            }
        }
        else {
            console.error('Updated label is undefined');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [labelManager, latestLabel, windowSize]);
}
exports.useOnAddLabel = useOnAddLabel;
